import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { Button, Card, Col, DatePicker, Descriptions, Form, message, Row } from "antd";
import { defaultCurrencyFormat, formRules } from "../../../../../utilities";
import moment from "moment";
import { CancellationReasonPicker } from "../../../../ui/forms/NotRenewingReasonPicker";
import { isEmpty } from "lodash";
import VHSpinner from "../../../../ui/VHSpinner";
import DefaultLayout from "../../../../layouts/DefaultLayout";

@inject("context")
@observer
class Cancellation extends Component {
	state = {
		name: "",
		quote: undefined,
	};

	componentDidMount() {
		this.doQuoteCancellationCalculation();
	}

	render() {
		if (isEmpty(this.state.quote)) {
			return <VHSpinner />;
		}

		return (
			<DefaultLayout>
				<Row>
					<Col xs={24}>
						<Card title={<h1>Cancellation</h1>}>
							<Row>
								<Descriptions column={1}>
									<Descriptions.Item label="Policy Number">
										{this.state.quote.policyNumber}
									</Descriptions.Item>
									<Descriptions.Item label="Policy Holder">
										{this.state.policyHolderName}
									</Descriptions.Item>
								</Descriptions>
							</Row>
							<Row>
								<Form
									layout="vertical"
									initialValues={{ cancellationDate: moment(new Date()) }}
								>
									<Row>
										<Col>
											<Form.Item
												name="cancellationReason"
												label="Cancellation Reason"
												rules={[formRules.required]}
											>
												<CancellationReasonPicker />
											</Form.Item>
										</Col>
									</Row>
									<Row>
										<Col>
											<Form.Item
												name="cancellationDate"
												label="Cancellation date"
												rules={[formRules.required]}
											>
												<DatePicker format="DD-MM-YYYY" onChange={this.handleDateChange} />
											</Form.Item>
										</Col>
									</Row>
								</Form>
							</Row>
							<Row>
								<Descriptions column={1}>
									<Descriptions.Item label="Amount Paid">
										{defaultCurrencyFormat(this.state.quote.total)}
									</Descriptions.Item>
									<Descriptions.Item label="Adjustment">
										{defaultCurrencyFormat(this.state.quote.premiumAdjustment)}
									</Descriptions.Item>
									<Descriptions.Item label="Cancellation fee">
										{defaultCurrencyFormat(this.state.quote.cancellationFee)}
									</Descriptions.Item>
									<Descriptions.Item label="Total Due/Refund">
										{defaultCurrencyFormat(this.state.quote.totalDueRefund)}
									</Descriptions.Item>
								</Descriptions>
							</Row>
							<Row>
								<Button type="default" onClick={() => this.handleCancel()}>
									Cancel
								</Button>
								<Button
									type="primary"
									style={{
										marginLeft: "15px",
									}}
									onClick={() => this.handleOk()}
								>
									OK
								</Button>
							</Row>
						</Card>
					</Col>
				</Row>
			</DefaultLayout>
		);
	}

	handleOk = () => {
		const { policiesService, paymentService } = this.props.context;

		this.props.form.validateFields(async (err, values) => {

			policiesService.hideCancellationModal();
			const cancelledPolicy = policiesService.cancellationModalRecord;
			const refundIssued = await paymentService.refund(
				cancelledPolicy.quoteId,
				cancelledPolicy.totalDueRefund
			);



			if (refundIssued) {

				await policiesService.cancelQuote(
					values.cancellationReason,
					values.cancellationDate.toISOString()
				);
				message.success("Successfully cancelled policy", 10);
				this.props.history.goBack();
			}


		});
	};

	handleCancel = async () => {
		const service = this.props.context.policiesService;

		service.setCancellationModalRecord(null);
		this.props.history.goBack();
	};

	handleDateChange = () => {
		const cancellationDate = this.props.form.getFieldValue("cancellationDate");
		this.doQuoteCancellationCalculation(cancellationDate.toISOString());
	};

	doQuoteCancellationCalculation = async () => {
		const service = this.props.context.policiesService;
		const quoteId = service.cancellationModalRecord.id;

		await service.calculateQuoteCancellation(new Date(), quoteId);
		const quote = service.cancellationModalRecord;
		this.setState({
			quote: quote,
			policyHolderName: `${quote.organisation.first_name} ${quote.organisation.last_name}`,
		});
	};
}

export default Cancellation;
